import * as React from 'react';

// tslint:disable:max-line-length
export const ResortIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fillRule="nonzero">
      <path d="M14.721 14l-.667-2h-2.108l.666 2H3.539L5.76 9.002 4.245 7.487 1.35 14H0v2h16v-2zM15 10h-5a1 1 0 0 1-.707-.293l-8-8A1 1 0 0 1 2.707.293L10.414 8H15a1 1 0 0 1 0 2z" />
    </g>
  </svg>
);
